import type { PlatformDecisionInput } from './platformRules';
import { evaluatePlatformRules } from './platformRules';
import type { PlatformDecision } from './platformTypes';

/**
 * Platform Brain — 唯一回答「今天哪些平台适合经营」
 *
 * 不负责素材、图片、影片、Workflow、MaterialPlan、ExecutionPlan。
 */
export function buildPlatformDecision(input: PlatformDecisionInput): PlatformDecision {
  const decision = evaluatePlatformRules(input.marketing, input.operation);

  if (!decision.platform_reason.length) {
    return {
      ...decision,
      platform_reason: ['使用基础平台节奏，默认 Threads。'],
    };
  }

  // 硬边界：禁止 hard 商业表达（类型已排除，运行时再夹一次）
  if ((decision.commercial_style as string) === 'hard') {
    return {
      ...decision,
      commercial_style: 'medium',
      platform_reason: [...decision.platform_reason, '商业表达上限为 medium，已降级。'],
    };
  }

  return decision;
}
